<template>
    <section :id="`PDI-asnwers-${step_id}`" class="PDI-asnwers">
        <div class="PDI-image-wrapper">
            {{ $t('feature.surveys.PDI.right_eye') }}
            <div class="PDI-image right_eye">
                <img src="../../../../assets/images/psp/PDI/right_eye.svg" alt="">
            </div>
        </div>
        <div class="PDI-image-wrapper">
            {{ $t('feature.surveys.PDI.left_eye') }}
            <div class="PDI-image left_eye">
                <img src="../../../../assets/images/psp/PDI/left_eye.svg" alt="">
            </div>
        </div>
        <div class="PDI-image-wrapper">
            <div class="PDI-image face">
                <img src="../../../../assets/images/psp/PDI/face.svg" alt="">
            </div>
        </div>
        <div class="PDI-image-wrapper">
            <div class="PDI-image top_head">
                <img src="../../../../assets/images/psp/PDI/top_head.svg" alt="">
            </div>
        </div>
    </section>

</template>
<style lang="scss">
.PDI-asnwers {
    // display: flex;
    display: grid;
    flex-wrap: wrap;
    gap: 4rem;
    padding: 1rem 0;
    justify-content: center;
    align-items: center;
    grid-template-columns: max-content;

    @media screen and (min-width: 576px) {
        grid-template-columns: max-content max-content;
    }

    @media screen and (min-width: 1400px) {
        grid-template-columns: max-content max-content max-content max-content;
    }

    .PDI-image-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: .5rem;
        text-transform: uppercase;
        font-size: 12px;
        
        .PDI-image {
            position: relative;
            display: block;
        }

        img {
            display: block;
        }
    }

    .PDI-point {
        --diameter: 30px;
        position: absolute;
        width: var(--diameter);
        height: var(--diameter);
        border-radius: 100px;
        transform: translate(-50%, -50%);
        background-color: #006EAB;
        opacity: .95;
    }
}
</style>
<script lang="ts">
import { PDIAnswer } from '@/utils/methods/survey_utils';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
    name: "PDIView",
    props: {
        step_id: {
            type: Number,
            required: true,
        },
        points: {
            type: Object as PropType<PDIAnswer | null>,
            required: false,

            // default: () => ({ "right_eye": [{ "x": 80.71183013916016, "y": 86.0 }, { "x": 144.04515838623047, "y": 58.666656494140625 }], "face": [{ "x": 54.53900146484375, "y": 140.60065460205078 }], "left_eye": [{ "x": 166.37850189208984, "y": 73.73265838623047 }] })
        },
    },
    mounted() {
        console.debug(this.points);
        this.render();
    },
    methods: {
        render() {
            const wrapper = document.getElementById(`PDI-asnwers-${this.step_id}`);
            try {
                if (this.points === null) return;
                for (const key of Object.keys(this.points!)) {
                    const coordinates = this.points![key];
                    let image = wrapper?.querySelector(`.${key}`);
                    image?.removeAttribute('hidden');
                    console.debug(key);
                    console.debug(coordinates);
                    for (let index = 0; index < coordinates.length; index++) {
                        const point = coordinates[index];
                        let p = document.createElement('span');
                        p.classList.add('PDI-point');
                        p.style.left = point.x.toFixed(2) + "px";
                        p.style.top = point.y.toFixed(2) + "px";
                        image?.appendChild(p);
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    }
})
</script>